import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const KMIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="KM" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#5196ED"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#AF0100"
          fillRule="evenodd"
          d="M0 6v3h16V6H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M0 3v3h16V3H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="M0 0v3h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#5EAA22"
          fillRule="evenodd"
          d="m0 0 10 6-10 6V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          d="M1.114 5.975c.073-2.25 2.358-2.802 2.998-2.332 0 0-1.825.382-1.888 2.332-.063 1.948 1.729 2.57 1.729 2.57-.682.18-2.912-.32-2.84-2.57Zm3.333 1.601.329.049-.239.235.057.333-.294-.157-.294.157.056-.333-.237-.235.328-.049.147-.304.147.304Zm0-1.018.329.048-.239.237.057.333-.294-.157-.294.157.056-.333-.237-.237.328-.048.147-.303.147.303Zm0-1.018.329.048-.239.236.057.333L4.3 6l-.294.157.056-.333-.237-.236.328-.048.147-.304.147.304Zm0-1.019.329.05-.239.235.057.334L4.3 4.98l-.294.159.056-.334-.237-.236.328-.049.147-.303.147.303Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
